export function navigate(href: string): void {
  window.location.href = href;
}
